import "./style/index.css";
import Rate from './Rate';
export { Rate };